/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RfqVendorActivityLog } from '../../models/rfq-vendor-activity-log';

export interface ApiVendorActivityLogGet$Params {
  pk?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorActivityLogGet(http: HttpClient, rootUrl: string, params?: ApiVendorActivityLogGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RfqVendorActivityLog>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorActivityLogGet.PATH, 'get');
  if (params) {
    rb.query('pk', params.pk, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RfqVendorActivityLog>>;
    })
  );
}

apiVendorActivityLogGet.PATH = '/api/vendor/activityLog';
